import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MyBusinessApiService } from '@app/modules/my-business/services/my-business.api.service';
import { MetricsFacade } from '@app/shared/+state/metrics/metrics.facade';
import { Filter } from '@app/shared/interfaces/lib/filter.interface';
import { LoadingState } from '@app/shared/interfaces';
import { catchError, of, switchMap } from 'rxjs';

@Component({
  selector: 'sbnb-profit-and-loss',
  templateUrl: './profit-and-loss.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfitAndLossComponent implements OnInit {
  public LoadingState = LoadingState;
  public filtersLoadingState$ = this.metricsFacade.journalLinesFiltersLoadingState$;
  public filters$ = this.metricsFacade.journalLinesFilters$;
  public appliedFilters$ = this.metricsFacade.journalLinesAppliedFilters$;

  public pnl$ = this.appliedFilters$.pipe(
    switchMap((filters) =>
      this.myBusinessApiService.getProfitAndLossReport(filters).pipe(
        // Careful, this is essentially swallowing this error for now while we are testing the filters
        catchError((error) => {
          return of(null);
        })
      )
    )
  );

  constructor(
    private metricsFacade: MetricsFacade,
    private myBusinessApiService: MyBusinessApiService
  ) {}

  ngOnInit() {
    this.metricsFacade.loadJournalLinesFilters();
  }

  onApplyFilter(filter: Filter) {
    this.metricsFacade.applyJournalLinesFilter(filter);
  }

  onAddFilter(filter: Filter) {
    this.metricsFacade.addJournalLinesFilter(filter);
  }

  onRemoveFilter(filter: Filter) {
    this.metricsFacade.removeJournalLinesFilter(filter);
  }
}
